import {
  tools,
  withHoverToolbar,
  type EditorPlugin,
} from '@aha-app/aha-editor-v2';
import EmbeddedReportComponent from './components/EmbeddedReportComponent';
import ToolConfigureReport from './tools/ToolConfigureReport';
import ToolOpenReport from './tools/ToolOpenReport';
import EmbeddedReportPlaceholderComponent from './components/EmbeddedReportPlaceholderComponent';

const EmbeddedReportComponentPlugin = ({ allowConfigure }): EditorPlugin => ({
  id: 'EmbeddedReportComponentPlugin',
  name: 'Embedded report component',
  components: [
    {
      type: 'embedded-report',
      component: withHoverToolbar(EmbeddedReportComponent, [ToolOpenReport]),
      toolbarItems: [
        [ToolOpenReport],
        allowConfigure ? [ToolConfigureReport] : null,
        [tools.ToolDelete],
      ].filter(Boolean),
    },
    {
      type: 'embedded-report-placeholder',
      component: EmbeddedReportPlaceholderComponent,
    },
  ],
});

export default EmbeddedReportComponentPlugin;
